import { BATCH_SIZE } from '../constants'

// A few at a time, because each download is held whole in memory until it is handed on.
export const inBatches = <Item>(items: Item[]): Item[][] => {
  const batches: Item[][] = []
  for (let start = 0; start < items.length; start += BATCH_SIZE) {
    batches.push(items.slice(start, start + BATCH_SIZE))
  }
  return batches
}
